import {Component} from '@angular/core';
 import * as XLSX from 'xlsx';
import {Product, ProductDetail} from '../../models/product.model';
import {Gallery} from '../../models/detailGalerie.model';
import {ProductService} from '../../my-products/shared/product.service';

@Component({
  selector: 'app-excel-upload',
  templateUrl: './excel-upload-component.component.html',
  styleUrls: ['./excel-upload-component.component.scss']
})
export class ExcelUploadComponent {
  products: Product[] = [];
  errorMessage: string = '';
  deleteInput: string = ''; // Holds the input value for deletion

  constructor(private productService : ProductService) {
    // Initialize products from the service
    this.productService.getProducts().subscribe((products: Product[]) => {
      this.products = products;
      console.log('Produits chargés :', this.products);
    }, (error) => {
      this.errorMessage = 'Erreur lors du chargement des produits : ' + error;
      console.error(this.errorMessage);
    });
  }



  private createId(product: Product): number {
    const randomId = Math.floor(Math.random() * new Date().getTime());
    let id = product.id || randomId;
    if (id === 1) {
      id = randomId;
    }
    // Ensure the ID is unique
    while (this.products.some(p => p.id === id)) {
      id = Math.floor(Math.random() * new Date().getTime());
    }
    return id;
  }


  onFileChange(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    // Extract the file name
    const fileName = file.name.split('.')[0]; // Get the name without extension
    console.log('Nom du fichier :', fileName);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheet];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Track existing SKUs to avoid duplicates
        const existingSkus = new Set(this.products.map(p => p.sku));
        const newProducts: Product[] = [];

        jsonData.forEach((row: any, index: number) => {
          const sku = row['SKU'] || '';
          // Skip if SKU already exists
          if (sku && existingSkus.has(sku)) {
            console.warn(`Produit avec SKU ${sku} déjà existant, ignoré.`);
            return;
          }

          const categories = this.elementsFromStringToObject(fileName);
          const familles = this.elementsFromStringToObject(row['Famille']);
          const sousFamilles = this.elementsFromStringToObject(row['SousFamille']);

          // Parser detail_Galerie comme JSON
          let detailGalerie: Gallery | null = null;
          let imageURLs: string[] = [row['Image URL'] || ''];
          try {
            if (row['detail_Galerie']) {
              detailGalerie = JSON.parse(row['detail_Galerie']);
              imageURLs = detailGalerie?.data?.map((img: any) => img.full).filter((url: string) => url) || imageURLs;
            }
          } catch (error) {
            console.warn('Erreur lors du parsing de detail_Galerie:', error);
          }

          // Create ProductDetail
          const productDetail = {
            fabricant: row['detail_Fabricant'] || '',
            fabricantUrl: row['detail_Fabricant URL'] || '',
            nomProduit: row['detail_Nom Produit'] || '',
            descriptionCourte: row['detail_Description Courte'] || '',
            baseline: row['detail_Baseline'] || '',
            disponibilite: row['detail_Disponibilité'] || '',
            prix: row['detail_Prix'] || '',
            descriptionLongue: row['detail_Description Longue'] || '',
            notesOlfactives: row['detail_Notes Olfactives'] || '',
            ingredients: row['detail_Ingrédients'] || '',
            detailsPrix: row['detail_Détails Prix'] || '',
            galerie: detailGalerie
          };

          const product =   new Product(
            0, // id
            new Date().toISOString(), // date
            row['Nom'] || '', // name
            row['Description'] || '', // description
            row['Prix Spécial'] ? Number(row['Prix Spécial']) : 0, // price
            row['Prix Normal'] ? Number(row['Prix Normal']) : 0, // priceNormal
            row['Prix Normal'] && row['Prix Spécial'] ? Number(row['Prix Normal']) - Number(row['Prix Spécial']) : 0, // reduction
            imageURLs, // imageURLs (de detail_Galerie ou Image URL)
            [], // imageRefs
            categories,
            familles, // familles
            sousFamilles, // sousFamilles
            {}, // ratings
            0, // currentRating
            !!row['Prix Spécial'] && row['Prix Spécial'] < row['Prix Normal'], // sale
            row['SKU'] || '', // sku
            row['Marque'] || '', // marque
            row['URL'] || '', // url
            productDetail
          );
          // Assign unique ID
          product.id = this.createId(product);

          newProducts.push(product);
          if (sku) existingSkus.add(sku);
        });

        // Append new products to existing ones
        this.products = [...this.products, ...newProducts];
        console.log('Produits mappés :', this.products);



        // Envoyer les produits à la Realtime Database
        this.productService.addProducts(newProducts).catch((error) => {
          this.errorMessage = 'Erreur lors de l\'envoi des produits à Firebase : ' + error;
        });
      } catch (error) {
        this.errorMessage = 'Erreur lors du traitement du fichier Excel : ' + error;
        console.error(error);
      }
    };
    reader.readAsArrayBuffer(file);
  }



  delete(): void {
    if (this.deleteInput.trim()) {
      console.log(`Deleting product: ${this.deleteInput}`);
      this.productService.deleteProduct2(this.deleteInput)
      this.deleteInput = ''; // Clear the input field after deletion
    } else {
      console.error('Input is empty. Cannot delete.');
    }
  }

  private elementsFromStringToObject(elements: string | undefined | null): Record<string, boolean> {
    // Input: 'cat1, cat2, cat3' || '' || null || undefined
    if (!elements || elements.trim().length === 0) {
      return {};
    }
    return elements
      .split(',')
      .map(item => item.trim())
      .filter(item => item) // Remove empty strings
      .reduce((combinedCategories, currentCategory) => {
        // Sanitize key for Firebase: replace invalid chars with underscore
        const sanitizedKey = currentCategory.replace(/[.#$/[\]]/g, '_');
        combinedCategories[sanitizedKey] = true;
        return combinedCategories;
      }, {} as Record<string, boolean>);
  }


}
